import type { JSX } from "react";

import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { type BoxProps, Box } from "@similarweb/ui-components/foundations";

const OuterBox = styled(Box)<{ $vertical?: boolean }>`
    position: relative;
    width: ${({ $vertical }) => ($vertical ? "1px" : "100%")};
    height: ${({ $vertical }) => ($vertical ? "100%" : "1px")};
`;

const InnerBox = styled(Box)<{ $vertical?: boolean }>`
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    min-width: 1px;
    min-height: 1px;
    background: ${colorsPalettes.navigation.BORDER_DARK_2};
`;

interface DividerProps extends BoxProps {
    children?: never;
    vertical?: boolean;
}

export const Divider = ({ vertical = false, ...boxProps }: DividerProps): JSX.Element => {
    return (
        <OuterBox
            {...boxProps}
            $vertical={vertical}
        >
            <InnerBox />
        </OuterBox>
    );
};
